import React from 'react'
import { getPortfolioData } from "../../data/portfolioData";
import "./Service.css"

const Service = () => {
    const { services} = getPortfolioData();
    return (
        <section className="service-section">
            <h2 className="section-title">My Services</h2>
            <div className="services-container">
                {services.map((service, index) => (
                    <div className="service-card" key={index}>
                        <img src={service.imgUrl} alt={service.title} className="service-image" />
                        <h3 className="service-title">{service.title}</h3>
                        <p className="service-description">{service.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Service;